import { React } from 'react';
import styled from 'styled-components';

function InputView(props) {
  const { isClicked, column, content } = props;

  return (
    <TopLevelWrpper>
      <Column>{column}</Column>
      <InputBox isClicked={isClicked}>
        <Content>{content}</Content>
      </InputBox>
    </TopLevelWrpper>
  )
}

export default InputView;

const TopLevelWrpper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;
`;

const InputBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  margin-top: 8px;

  width: 363px;
  height: 30px;

  border: 1px solid #DFDFDF;
  border-radius: 8px;
  background-color: ${props => props.isClicked ? `rgba(255, 139, 72, 0.7)` : `#FFFFFF`};

`;

const Column = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: #595959;

  margin: 0 0 0 0;

  &:hover {
    cursor: pointer;
  } 
`;

const Content = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #232323;

  margin: 0 0 0 8px;

  &:hover {
    cursor: pointer;
  } 
`;